import { useEffect } from 'react';

import { Reload } from '@travel/icons/ui';
import UIPagination from '@travel/traveler-core/components/Pagination';
import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { useInView } from 'react-intersection-observer';

import styles from './pagination.module.scss';
import PaginationLabelResolver from './PaginationLabelResolver';

type Props = {
  limit: number;
  offset: number;
  total: number;
  isFetching?: boolean;
  onLoadNextPage?: () => void;
  onClickPaginationButton?: (offset: number, limit: number) => void;
  isPlanList: boolean;
};

function Pagination(props: Props) {
  const { limit, offset, total, isFetching, onLoadNextPage, onClickPaginationButton, isPlanList } =
    props;

  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;

  const [ref, inView] = useInView({ rootMargin: '0px' });
  const hasMore = limit + offset < total;

  useEffect(() => {
    if (!isFetching && inView && hasMore) {
      onLoadNextPage?.();
    }
  }, [inView, hasMore, isFetching, onLoadNextPage]);

  return (
    <>
      {isSP ? (
        hasMore && !isFetching ? (
          <div ref={ref} className={styles.loading}>
            <Reload size={24} color="cilantro" className={styles.icon} />
          </div>
        ) : null
      ) : (
        <UIPagination
          customStyle={'pagination'}
          total={total}
          limit={limit}
          offset={offset}
          className={styles.loadmoreBox}
          callback={onClickPaginationButton}
          navigationType="domestic"
          paginationLabelResolver={PaginationLabelResolver(isPlanList)}
          isPaginationDisplayOnSinglePage={true}
          paginationButtonWrapperClassName={styles.paginationButtonWrapper}
          paginationButtonClassName={styles.paginationButton}
          paginationActiveButtonClassName={styles.paginationActiveButton}
          reviewCountSymbol="～"
        />
      )}
    </>
  );
}

export default Pagination;
